import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import Select from 'react-select'
import CustomSelect from '../../views/pages/Select'

import { Button, Input, Spinner } from 'reactstrap'

import {
  setLayouts,
  setCurrentDashboardId,
  setToolbox,
  handleToggleItem,
  handleCancel,
  saveLayout,
} from 'store/Dashboard/actions'
import { setIsBlocking } from 'store/ConfigurationSettings/GeneralConfig/actions'

import { toggleScaledDashboard } from 'store/user/actions'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { setEditBreakpoint } from 'store/Dashboard/actions'

// Admin Navbar css
import './AdminNavbar.css'

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 33,
    height: 33,
  }),
  placeholder: (base) => ({
    ...base,
    lineHeight: '19px',
    paddingBottom: '5px',
    fontSize: '14px',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingBottom: '10px',
  }),
}

function EditDashboard() {
  const location = useLocation()
  const scaledDashboard = useSelector((state) => state.auth.scaledDashboard)
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth.user)
  const { savingLayout, dashboards, currentDashboardId, toolbox, layouts } =
    useSelector((state) => state.dashboard)

  const [viewport, setViewport] = useState('lg')

  function convertObjectDataTypes(obj) {
    const layout = { ...obj.layout }
    for (const key in layout) {
      if (key !== 'i') {
        const value =
          layout[key].toLowerCase && layout[key].toLowerCase() === 'false'
            ? false
            : Number(layout[key])
        layout[key] = isNaN(value) ? layout[key] : value
      }
    }
    return {
      ...obj,
      active:
        typeof obj.active === 'boolean'
          ? obj.active
          : obj.active
          ? obj.active.toString().toLowerCase() === 'true'
          : false,
      layout,
    }
  }

  function parseIfString(value) {
    return typeof value === 'string' ? JSON.parse(value) : value
  }

  const selectOptions = [
    { name: 'lg', value: 'lg' },
    { name: 'md', value: 'md' },
    { name: 'sm', value: 'sm' },
  ]

  return (
    <>
      {location.pathname.includes('/dashboard') && user.access === 1 && (
        <>
          {!scaledDashboard ? (
            <div className='aling-self-center'>
              <div className='d-flex align-items-center'>
                <h3 className='text-white pb-0 mb-0 mr-2'>DASHBOARD</h3>
                <Button
                  color='transparent'
                  className='btn-icon-only btn-sm shadow-none edit-dashboard-button'
                  onClick={() => {
                    dispatch(setIsBlocking(true))
                    dispatch(toggleScaledDashboard(!scaledDashboard))
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} size='lg' className=' icon' />
                </Button>
              </div>
            </div>
          ) : (
            <>
              <div className='d-flex align-items-start'>
                <div className='d-flex flex-column mb-1'>
                  <div className='d-flex align-items-center '>
                    <Button
                      color='white'
                      className='px-4 py-1'
                      onClick={() => {
                        dispatch(setIsBlocking(false))
                        dispatch(saveLayout())
                        dispatch(handleCancel())
                      }}
                    >
                      {savingLayout && <Spinner size='sm' />} Save
                    </Button>
                    <Button
                      color='white'
                      className='px-4 py-1 ml-1'
                      outline
                      onClick={() => {
                        dispatch(setIsBlocking(false))
                        dispatch(handleCancel())
                        dispatch(toggleScaledDashboard(!scaledDashboard))
                      }}
                    >
                      Cancel
                    </Button>
                    <div className='ml-2'>
                      {/* <CustomSelect
                        options={selectOptions}
                        onChange={(e) => {
                          dispatch(setEditBreakpoint(e.option.value))
                          setViewport(e.option.value)
                        }}
                        placeholder={viewport}
                        multi={false}
                        height={30}
                      /> */}
                      <Input
                        onChange={(e) => {
                          dispatch(setEditBreakpoint(e.target.value))
                        }}
                        type='select'
                        size='sm'
                      >
                        <option value='lg'>lg</option>
                        <option value='md'>md</option>
                        <option value='sm'>sm</option>
                      </Input>
                    </div>
                  </div>

                  <div className='d-flex mt-4 bottom-0'>
                    {dashboards.map((dashboard) => (
                      // <label className='mr-2' key={dashboard.id}>
                      // 	<input
                      // 		type='radio'
                      // 		class='option-input radio'
                      // 		checked={dashboard.id === currentDashboardId}
                      // 		onChange={() => {
                      // 			dispatch(setCurrentDashboardId(dashboard.id))
                      // 			dispatch(
                      // 				setLayouts(JSON.parse(dashboard.data))
                      // 			)
                      // 			dispatch(
                      // 				setToolbox(JSON.parse(dashboard.toolbox))
                      // 			)
                      // 		}}
                      // 		name={dashboard.name}
                      // 	/>
                      // 	<span className='text-white'>
                      // 		{dashboard.name}
                      // 	</span>
                      // </label>
                      <div
                        className='custom-control custom-radio dashboard-radio mr-2'
                        key={dashboard.id}
                      >
                        <input
                          className='custom-control-input bg-default'
                          checked={dashboard.id === currentDashboardId}
                          onChange={() => {
                            dispatch(setCurrentDashboardId(dashboard.id))
                            const parsedData = parseIfString(dashboard.data)
                            const parsedToolbox = parseIfString(
                              dashboard.toolbox
                            )

                            dispatch(setLayouts(parsedData))
                            dispatch(setToolbox(parsedToolbox))
                            // dispatch(setLayouts(JSON.parse(dashboard.data)));
                            // dispatch(setToolbox(JSON.parse(dashboard.toolbox)));
                            // dispatch(setLayouts(dashboard.data));
                            // dispatch(setToolbox(dashboard.toolbox));
                          }}
                          name={dashboard.name}
                          id={dashboard.name}
                          type='radio'
                        />
                        <label
                          className='custom-control-label text-white'
                          style={{ paddingTop: '1px' }}
                          htmlFor={dashboard.name}
                        >
                          {dashboard.name}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className='positon-absolute right-0 left-0 align-self-start add-widget'>
                {console.log('leart225', toolbox)}
                <Select
                  closeMenuOnSelect={false}
                  styles={customStyles}
                  controlShouldRenderValue={false}
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  placeholder='Add dashboard widget'
                  options={toolbox
                    ?.map((toolbox) => convertObjectDataTypes(toolbox))
                    ?.filter((filItem) => {
                      return !filItem.active
                    })
                    ?.map((item) => ({
                      value: item.name,
                      label: (
                        <div
                          className={`nav-link-text ml-4 ${
                            item.active ? '' : 'text-default'
                          } ml-1`}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            dispatch(
                              handleToggleItem(convertObjectDataTypes(item))
                            )
                          }}
                        >
                          {item.name}
                        </div>
                      ),
                    }))}
                />
              </div>
            </>
          )}
        </>
      )}
    </>
  )
}

export default EditDashboard
